<div class="contents-area">
  <div class="block-row">
    <div class="column-list">
      <label class="list-input-title">受注コード</label>
      <div class="list-input-content">
        <app-order-code-text-input id="txi_OrderCode" #txi_OrderCode [subid]="'txi_OrderCode'" [required]="true"
          [catalogIDField]="txi_DelivCatalog" [autofocus]="true" [(ngModel)]="kymw2300Model.orderCode"
          (ngModelChange)="bindOrderCodeEvent()" [forcedEnabledMode]="'true'" [tabindex]="0">
        </app-order-code-text-input>
      </div>

      <label class="list-input-title">配達企画回(翌週)</label>
      <div class="list-input-content">
        <input type="text" class="deliv-catalog" id="txi_DelivCatalog" #txi_DelivCatalog readonly/>
      </div>
    </div>
    <div class="column-list">
      <label class="list-input-title">媒体</label>
      <div class="list-input-content" style="width: 300px;">
        <app-koma-medium-type-combo-box id="cmb_Medium" #cmb_Medium [subid]="'cmb_Medium'"
          [(ngModel)]="kymw2300Model.mediumType" [required]="true"
          [orderCodeMediumeTypeClear]="txi_OrderCode.selectedOrderCode" (change)="bindMediumTypetEvent()"
          [forcedEnabledMode]="'true'" [tabindex]="0" style="width: 100%;">
        </app-koma-medium-type-combo-box>
      </div>

      <label class="list-input-title">会員生協</label>
      <div class="list-input-content">
        <app-coop-code-combo-box id="cmb_Coop" #cmb_Coop [subid]="'cmb_Coop'" [(ngModel)]="kymw2300Model.coopCode"
          [required]="true" [allCoop]="true" (change)="bindCoopCodeEvent()" [forcedEnabledMode]="'true'" [tabindex]="0">
        </app-coop-code-combo-box>
      </div>
    </div>
  </div>

  <div class="block-row">
    <div>
      <h2>ページ一覧</h2>
      <div class="element-column">
        <div class="layout_end">
          <button class="btn-tartiary" id="btn_AllCheck" #btn_AllCheck (click)="eventBtnAllCheck_CLICKHandler()"
            forcedEnabledMode="none" [tabindex]="0">全選択</button>
          <button class="btn-tartiary" id="btn_AllUnCheck" #btn_AllUnCheck (click)="eventBtnAllUnCheckt_CLICKHandler()"
            forcedEnabledMode="none" [tabindex]="-1">全解除</button>
        </div>
        <wj-flex-grid #dgv_PageList id="dgv_PageList" class="wj-flexgrid"
          [itemsSource]="kymw2300Model.pageList" #PageList verticalScrollPolicy="on" liveScrolling="false"
          dragEnabled="false" resizableColumns="false" sortableColumns="false" [allowDragging]="'None'"
          [isReadOnly]="true" [deferResizing]="false" [allowResizing]="true" [allowSorting]="false"
          [headersVisibility]="'Column'" [selectionMode]="'Row'" [tabindex]="-1">
          <wj-flex-grid-column [minWidth]="5" [header]="'選択'" [width]="45" [binding]="'Selected'" [align]="'center'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <input type="checkbox" class="selected" [(ngModel)]="cell.item.Selected" [tabindex]="-1"
                id="cb_page_list_{{cell.row.index}}" (mouseup)="$event.stopPropagation()" />
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'ページ'" [width]="60" [binding]="'PageNum'" [align]="'left'">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'ページ名称'" [width]="356" [binding]="'PageInfo'" [align]="'left'">
          </wj-flex-grid-column>
        </wj-flex-grid>
      </div>
    </div>
    <div class="block-column">
      <div>
        <h2>出力指定</h2>
        <div class="block-row">
          <app-checkbox-label label="入稿データ" id="ckb_Manuscripts" #ckb_Manuscripts [subid]="'ckb_Manuscripts'"
            [forcedEnabledMode]="'true'" [tabindex]="0"></app-checkbox-label>
          <app-checkbox-label label="差分リスト（編集）" id="ckb_EditDifferenceList" #ckb_EditDifferenceList
            [subid]="'ckb_EditDifferenceList'" [forcedEnabledMode]="'true'" [tabindex]="0"></app-checkbox-label>
          <app-checkbox-label label="差分リスト（バイヤー）" id="ckb_BuyerDifferenceList" #ckb_BuyerDifferenceList
            [subid]="'ckb_BuyerDifferenceList'" [forcedEnabledMode]="'true'" [tabindex]="0"></app-checkbox-label>
        </div>
      </div>
      <div>
        <h2>出力条件</h2>
        <div class="column-list" style="width:470px;">
          <label class="list-input-title">出力対象</label>
          <div class="list-input-content">
            <app-code-combo-box id="cmb_TargetProgress" #cmb_TargetProgress [subid]="'cmb_TargetProgress'"
              [required]="true" [codeDiv]="'ctp004'" [labelField]="'codeValueName'" [conReserveNum1]="'1'"
              [latestInfo]="true" (change)="eventCmbTargetProgress_CHANGEHandler()" [forcedEnabledMode]="'true'"
              [tabindex]="0">
            </app-code-combo-box>
          </div>

        <label class="list-input-title">比較フェーズ</label>
        <div class="list-input-content">
          <app-code-combo-box id="cmb_CompareProgress" #cmb_CompareProgress [subid]="'cmb_CompareProgress'"
            [required]="false" [codeDiv]="'ctp004'" [labelField]="'codeValueName'" [blank]="true" [conReserveNum1]="'1'"
            (change)="eventCmbCompareProgress_CHANGEHandler()" [forcedEnabledMode]="'true'" [tabindex]="0">
          </app-code-combo-box>
        </div>

        <label class="list-input-title">出力方法</label>
        <div class="list-input-content">
          <app-radio-label name="grp_outputType" label="全て" value="0" id="rdb_All" #rdb_All [subid]="'rdb_All'"
            [(ngModel)]="kymw2300Model.outputType" [forcedEnabledMode]="'true'" [tabindex]="0">
          </app-radio-label>
          <app-radio-label name="grp_outputType" label="差分" value="1" id="rdb_Diff" #rdb_Diff [subid]="'rdb_Diff'"
            [(ngModel)]="kymw2300Model.outputType" [forcedEnabledMode]="'none'" [tabindex]="0">
          </app-radio-label>
        </div>
      </div>
    </div>
  </div>
</div>

<footer class="footer-buttons">
  <button class="btn-secondary" id="btn_Output" #btn_Output (click)="eventBtnOutputThumbnail_CLICKHandler()"
    forcedEnabledMode="none" [tabindex]="0">サムネイル用データを出力</button>
  <button class="btn-primary" id="btn_Output_Thumbnail" #btn_Output_Thumbnail (click)="eventBtnOutput_CLICKHandler()"
    forcedEnabledMode="none" [tabindex]="0">出力</button>
</footer>